import * as React from "react";
function SvgChevronDownSm(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <g clipPath="url(#chevron-down-sm_svg__clip0_131_22)">
                <path
                    d="M11.986 15.76a1.151 1.151 0 01-.865-.39L6.216 9.794a.923.923 0 011.386-1.22l4.29 4.877a.125.125 0 00.188 0l4.29-4.876a.923.923 0 111.386 1.22l-4.904 5.573a1.155 1.155 0 01-.866.392z"
                    fill="currentcolor"
                />
            </g>
            <defs>
                <clipPath id="chevron-down-sm_svg__clip0_131_22">
                    <path fill="#fff" d="M0 0h24v24H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgChevronDownSm);
export default ForwardRef;
